import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { useTranslation } from "react-i18next";
import { Controller, UseFormMethods, FieldError } from "react-hook-form";
import { SUBSCRIPTION_TYPES } from "@constants";
import { useEffect } from "react";

interface ISubscription {
    control: UseFormMethods["control"];
    prefix?: string;
    error: FieldError | undefined;
    isOfferPort: boolean;
    provider?: string;
    isPrepaid: boolean;
    setSubscription: any;
}

const SubscriptionDropdown = (props: ISubscription) => {
    const { t } = useTranslation(["portin", "validation"]);
    const { control, error, isOfferPort, provider, isPrepaid, setSubscription } = props;
    const subscriptionList = SUBSCRIPTION_TYPES.map((sub) => ({ value: sub.value, label: sub.label }));

    useEffect(() => {
        if (isPrepaid || provider === "OT") {
            control.setValue("currentSubscription", "PR");
            setSubscription("PR");
        }
    }, [provider]);

    return (
        <Controller
            control={control}
            name={"currentSubscription"}
            rules={{
                required: t("validation:required"),
            }}
            render={(renderProps) => (
                <TextField
                    disabled={isOfferPort || isPrepaid || provider === "OT"}
                    fullWidth
                    id="currentSubscription"
                    inputRef={renderProps.ref}
                    label={`${t("portin:subscriptionType")} *`}
                    margin="dense"
                    name="currentSubscription"
                    select
                    value={renderProps.value || ""}
                    onChange={(event) => {
                        setSubscription(event.target.value);
                        return renderProps.onChange(event);
                    }}
                    error={Boolean(error?.message)}
                    helperText={error?.message}
                >
                    {subscriptionList.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            )}
        />
    );
};

export default SubscriptionDropdown;
